import React, { useState, useEffect } from 'react';
import api from '../../../api';

const ShinyPotionIndicator = ({ expirationOverride }) => {
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkShinyPotionStatus = async () => {
      try {
        const response = await api.get("/v1/shiny-potion-status");
        if (response.data.active) {
          const remainingSeconds = Math.max(0, response.data.expiration - Math.floor(Date.now() / 1000));
          setTimeRemaining(remainingSeconds);
        } else {
          setTimeRemaining(null);
        }
      } catch (error) {
        console.error('Error checking shiny potion status:', error);
        setTimeRemaining(null);
      } finally {
        setLoading(false);
      }
    };

    // Check status immediately and then every 30 seconds
    checkShinyPotionStatus();
    const statusInterval = setInterval(checkShinyPotionStatus, 30000);

    return () => clearInterval(statusInterval);
  }, []);

  // Handle countdown timer
  useEffect(() => {
    if (timeRemaining > 0) {
      const countdownInterval = setInterval(() => {
        setTimeRemaining(prev => {
          const newTime = prev - 1;
          if (newTime <= 0) {
            clearInterval(countdownInterval);
            return null;
          }
          return newTime;
        });
      }, 1000);

      return () => clearInterval(countdownInterval);
    }
  }, [timeRemaining]);

  // Effect to handle expirationOverride prop changes
  useEffect(() => {
    if (expirationOverride) {
      const remainingSeconds = Math.max(0, expirationOverride - Math.floor(Date.now() / 1000));
      setTimeRemaining(remainingSeconds);
      setLoading(false);
    }
  }, [expirationOverride]);

  if (loading) return null;
  if (!timeRemaining) return null;

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <div 
      style={{
        position: 'fixed',
        top: '300px', // Position below the mineral potion indicator
        right: '10px',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        color: 'white',
        padding: '4px',
        borderRadius: '6px',
        fontSize: '12px',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        zIndex: 1000,
        boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
      }}
    >
      <div style={{ position: 'relative', width: '24px', height: '24px', marginRight: '4px' }}>
        <img 
          src={require('../../../assets/images/items/ShinyPotion.png')}
          alt="Shiny Potion" 
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </div>
      {formatTime(timeRemaining)}
    </div>
  );
};

export default ShinyPotionIndicator;